
import { Col, Row, Form, Input, DatePicker, Radio, Statistic, Tooltip, Button, Checkbox } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import { ReactComponent as EditIcon } from '../../../../assets/images/svg/i_edit.svg';
import { FormOTPInput } from '../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE, NAME_REGEX, PHONE_NUMBER_REGEX, PHR_REGEX, TOOLTIP_TEXT } from '../../../../shared/constants/commonConstants';
import { RootState } from '../../../../store';
import './IdCard.less';
import { defaultImg } from '../../../../assets/images/id-card-header';

export const GetPhoneNumber = ({ setEnableNextButton }: any): ReactElement | null => {
  const mobileNumberOnChangeHandler = (e: any): any => {
    const { target: { value }} = e;
    const isValidMobileNo = PHONE_NUMBER_REGEX.test(value);
    setEnableNextButton(!isValidMobileNo);
  };

  return <Row gutter={GUTTOR_SPACE}>
    <Col md={20} offset={2}>
      <Form.Item
        data-testid="phone-number"
        label="Enter you 10 digit mobile number"
        name="number"
        rules={[{ required: true, pattern: PHONE_NUMBER_REGEX, message: 'Please enter valid Mobile No.!' }]}
      >
        <Input
          placeholder="Mobile No."
          prefix={'+91'}
          maxLength={10}
          onChange={mobileNumberOnChangeHandler}
        />
      </Form.Item>
    </Col>
  </Row>;
};
export const GetAdhaarNumber = ({setEnableNextButton}: any): ReactElement | null => {
  const [agreeAdharTearms, setAgreeAdharTearms] = useState(false);
  const [adharValidated, setAdharValidated] = useState(false);
  const agreeAdharTearmsChangeHandler =  (e: any): any => {
  // change in function to disabled the button until the required fieds are filled
    if (e.target.checked === true) {
      setAgreeAdharTearms(true);
      setEnableNextButton(false);
    } else {
      setAgreeAdharTearms(false);
      setEnableNextButton(true);
    }
  };
  const onChangeAdhar = (e: any): any => {
    const regex = /^[0-9]{12}$/; // Regular expression to match digits only
    if (e?.target?.value === undefined || !(regex.test(e.target.value))) {
      setAdharValidated(false);
      setAgreeAdharTearms(false);
      setEnableNextButton(true);
    } else {
      setAdharValidated(true);
      setEnableNextButton(!agreeAdharTearms);
    }
  };

  return <Row gutter={GUTTOR_SPACE}>
    <Col md={20} offset={2}>
      <Form.Item
        data-testid="adhaar-number"
        label="Enter your Aadhaar Card Number"
        name="aadhaar"
        rules={[{ required: true, min: 12, pattern: /^[0-9]{12}$/, message: 'Please Enter Valid Aadhaar No.!' } ]}>
        <Input placeholder="Aadhaar No." maxLength={12} onChange={onChangeAdhar}/>
      </Form.Item>
    </Col>
    <Col md={20} offset={2} className="adhar-tearms-wrapper">
      I, hereby declare that I am voluntarily sharing my Aadhaar Number and demographic
      information issued by UIDAI, with National Health Authority (NHA) for the sole purpose of
      creation of ABHA number . I understand that my ABHA number can be used and shared for purposes
      as may be notified by ABDM from time to time including provision of healthcare services.
      Further, I am aware that my personal identifiable information (Name, Address, Age, Date of Birth,
      Gender and Photograph) may be made available to the entities working in the National Digital Health
      Ecosystem (NDHE) which inter alia includes stakeholders and entities such as healthcare professionals
      (e.g. doctors), facilities (e.g. hospitals, laboratories) and data fiduciaries (e.g. health programmes),
      which are registered with or linked to the Ayushman Bharat Digital Mission (ABDM), and various
      processes there under. I authorize NHA to use my Aadhaar number for performing Aadhaar based
      authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and
      other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI
      will share my e-KYC details, or response of “Yes” with NHA upon successful authentication. I have been
      duly informed about the option of using other IDs apart from Aadhaar; however, I consciously choose to
      use Aadhaar number for the purpose of availing benefits across the NDHE. I am aware that my personal
      identifiable information excluding Aadhaar number / VID number can be used and shared for purposes as
      mentioned above. I reserve the right to revoke the given consent at any point of time as per provisions
      of Aadhaar Act and Regulations.
    </Col>

    <Col md={22} offset={2}>
      <Checkbox
         onChange= {agreeAdharTearmsChangeHandler}
          checked={adharValidated && agreeAdharTearms}
          disabled={!adharValidated}
      /> I agree
    </Col>
  </Row>;
};

export const GetOTP = ({ form, previous, resendOTP, otpTimeout }: any): ReactElement | null => {
  const [resend, setResend] = useState(0);
  const [resendText, setResendText] = useState('Resend OTP in');
  const contactNumber = form.getFieldValue('number') || form.getFieldValue('aadhaar');
  const Countdown = Statistic.Countdown;
  const deadline = Date.now() + otpTimeout;

  const onFinish = (): any => {
    setResendText(`Didn't receive OTP?`);
    setResend((prevState: any): any => prevState + 1);
  };

  const resendComponent = resend > 0 ? <p className="resend-link" onClick={(): any => resendOTP({number: contactNumber})}>
    Resend </p> : <Countdown value={deadline} format="mm:ss" onFinish={onFinish} />;

  return (<><Row gutter={GUTTOR_SPACE}>
    <Col md={20} offset={2}>
      <label>Enter OTP received on your mobile number </label>
    </Col>
  </Row>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={10} offset={7}>
        {contactNumber}
        <Tooltip title={TOOLTIP_TEXT.edit}><EditIcon onClick={previous} /></Tooltip>
      </Col>
    </Row>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={20} offset={3}>
        <FormOTPInput
          form={form}
          autoFocus={true}
          length={6}
          className="otpContainer"
          inputClassName="otpInput"
        />
      </Col>
    </Row>
    <Row gutter={GUTTOR_SPACE} className="otp-component-text">
      <Col md={9} offset={4}>
        {`${resendText}`}
      </Col>
      <Col>{resendComponent}
      </Col>
    </Row></>);
};

export const GetHealthIdForm = ({form}: any): ReactElement | null => {
  const { userInfo } = useSelector((state: RootState): any => state.idCard);
  const {name, gender, birthdate} = userInfo;

  useEffect((): any => {
    form.setFields([
      {
        name: 'name',
        value: name,
      },
      {
        name: 'dob',
        value: birthdate,
      },
      {
        name: 'gender',
        value: gender,
      },
    ]);
  }, []);

  return <> { userInfo !== '' ? <>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={24}>
        <Form.Item
          data-testid="phr-add"
          label="ABHA Address"
          name="phrAddress"
          rules={[{ required: true, pattern: PHR_REGEX, message: 'Please enter valid ABHA address!' },
          { min: 4, message: 'ABHA address must be minimum 4 characters.' }]}
        >
          <Input
            placeholder="ABHA Address"
            maxLength={32}
            suffix={'@ndhm'}
          />
        </Form.Item>
      </Col>
    </Row>
  </> :  null}
  </>;
};

export const GetForm = (): ReactElement | null => {
  return <> <Row gutter={GUTTOR_SPACE}>
    <Col md={24}>
      <Form.Item
        data-testid="full-name"
        label="Full name"
        name="name"
        rules={[{ required: true, pattern: NAME_REGEX, message: 'Please enter valid full name!' }]}
      >
        <Input placeholder="Full name" />
      </Form.Item>
    </Col>
  </Row>
  <Row gutter={GUTTOR_SPACE}>
    <Col md={24}>
      <Form.Item
        data-testid="phr-add"
        label="PHR Address"
        name="healthId"
        rules={[{ required: true, pattern: PHR_REGEX, message: 'Please enter valid phr!' },
        { min: 4, message: 'PHR must be minimum 4 characters.' }]}
      >
        <Input placeholder="PHR Address" maxLength={32} suffix={'@ndhm'}/>
      </Form.Item>
    </Col>
  </Row>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={24}>
        <Form.Item name="dob" data-testid="dob" label="Date Of Birth" rules={[{ required: true }]}>
          <DatePicker className="bottom-brdr-picker" format={'DD/MM/YYYY'}
            placeholder="dd/mm/yyyy" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={24}>
        <Form.Item
          label="Gender"
          name="gender"
          rules={[
            { required: true },
            { message: 'Please Select Valid Option' },
          ]}
          initialValue={'F'}
        >
          <Radio.Group>
            <Radio value="M" name="M" data-testid="male">Male</Radio>
            <Radio value="F" name="F" data-testid="female">Female</Radio>
            <Radio value="O" name="O" data-testid="other">Other</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  </>;
};

export const GetCard = (): ReactElement | null => {
  const { idCardInfo, downLoadIdCardInfo } = useSelector((state: RootState): any => state.idCard);

  const printID = (): any => {
    const doc = new jsPDF('portrait', 'pt');
    const pdfjs = document?.getElementById('id-card') ? document.getElementById('id-card') : '';

    // Convert HTML to PDF in JavaScript
    doc.html(pdfjs ? pdfjs : '', {
      callback: (): any => {
        doc.autoPrint();
        window.open(doc.output('bloburl'));
      }, x: 120, y: 120,
    });
  };

  return <React.Fragment>
    <Row className="id-card" id="id-card">
      <Col md={24}>
        <img
          src={ idCardInfo ? `data:image/png;base64,${idCardInfo.healthcard}` : `data:image/png;base64,${defaultImg}`}
          alt="Profile"
          width="100%"
          onError={(): any => { require('../../../../assets/images/svg/i_contact.svg'); }}
        />
      </Col>
    </Row>
    <Row gutter={GUTTOR_SPACE}>
      <Col md={10} offset={2}>
        <Button onClick={(): void => printID()} data-testid="print">
          Print ID
        </Button>
      </Col>
      <Col md={10}>
        <a download="id-card.pdf" href={`data:image/pdf;base64,${downLoadIdCardInfo.healthcard}`}>
          <Button  type={'primary'} data-testid="download-id">
            Download ID
          </Button>
        </a>
      </Col> </Row>
  </React.Fragment>;
};

export const DownloadCertificate = (): ReactElement | null => {
  const { certificate } = useSelector((state: RootState): any => state.idCard);
  return <a download="cowin-cert" href={`data:application/pdf;base64,${certificate}`}>
     <Button type={'primary'} data-testid="download">
          Download
        </Button>
    </a>;
};
